export enum TabType {
    FindByName = 'FindByName',
    InviteFriends = 'InviteFriends',
    TeamInvites = 'TeamInvites',
    OpenTeams = 'OpenTeams'
}
